var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffeeTableSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 363.789 363.789",
    style: {
      enableBackground: "new 0 0 363.789 363.789"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M310.392,10.44h-8.42V0h-62.58v47.53c0,13.62,11.05,24.67,24.67,24.67h13.24   c12.7,0,23.162-9.609,24.517-21.95h8.573c9.44,0,17.12-7.676,17.12-17.11v-5.59C327.512,18.115,319.832,10.44,310.392,10.44z    M315.512,33.14c0,2.818-2.297,5.11-5.12,5.11h-8.42V22.44h8.42c2.823,0,5.12,2.292,5.12,5.11V33.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M262.725,47.53V0h-23.333v47.53c0,13.62,11.05,24.67,24.67,24.67h13.24   c1.73,0,3.417-0.18,5.047-0.519C271.147,69.35,262.725,59.42,262.725,47.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M124.391,0v47.53c0,13.62-11.05,24.67-24.67,24.67h-13.24c-13.62,0-24.66-11.05-24.66-24.67v-3.28   V16.44V0H124.391"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M85.155,47.53V0H61.821v10.44h-8.43c-9.435,0-17.11,7.676-17.11,17.11v5.59   c0,9.434,7.675,17.11,17.11,17.11h8.583C63.33,62.59,73.791,72.2,86.492,72.2h13.24c1.73,0,3.417-0.18,5.047-0.519   C93.577,69.35,85.155,59.42,85.155,47.53z M48.281,33.14v-5.59c0-2.818,2.292-5.11,5.11-5.11h8.43v15.81h-8.43   C50.574,38.25,48.281,35.958,48.281,33.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M358.024,70.199v28.12h-33.34v32.09h-126.92v204.3h33.059c6.88,0,12.885,4.661,14.593,11.326   l4.549,17.755h-136.13l4.541-17.75c1.706-6.667,7.712-11.33,14.594-11.33h33.055v-204.3H39.104v-32.09H5.764v-28.12H358.024z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5A030"
    },
    points: "324.685,98.319 324.685,112.409 104.644,112.409 104.644,130.409 39.104,130.409    39.104,98.319 5.764,98.319 5.764,70.199 71.304,70.199 71.304,98.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5A030"
    },
    points: "197.764,130.409 166.024,130.409 166.024,334.709 175.664,334.709 175.664,167.829    197.764,167.829  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5A030"
    },
    d: "M132.966,334.709h20.975l-7.44,29.08h-32.67l4.541-17.75   C120.078,339.372,126.085,334.709,132.966,334.709z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeTableSvgrepoCom);
export default __webpack_public_path__ + "static/media/coffee-table-svgrepo-com.b80444aae53f8dc6becda1f8a65c0f4b.svg";
export { ForwardRef as ReactComponent };